import React from 'react';
import {useSelector} from 'react-redux';
import CurrencyItem from './CurrencyItem';
import CustomScrollbars from '../../utils/CustomScrollbars';

const CurrencySwitcher = ({switchCurrency, handleRequestClose}) => {
  const { currency } = useSelector(({settings}) => settings);
  let boxHeight = 265;
  
  return (
    <CustomScrollbars className="messages-list language-list scrollbar" style={{height: 80}}>
      <ul className="list-unstyled">
        { currency.length > 0 && currency.map(curr => <CurrencyItem key={curr.code} currency={curr}
            handleRequestClose={handleRequestClose} switchCurrency={switchCurrency}/>)
        }
      </ul>
    </CustomScrollbars>
  )
};

export default CurrencySwitcher;

